<template>
  <div>
    <v-card min-height="550">
      <v-dialog
        v-model="deleteWarningDialog"
        transition="dialog-top-transition"
        max-width="500"
      >
        <template>
          <v-card rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                Warning
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                icon
                class="white--text"
                @click="deleteWarningDialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text
              class="black--text pt-5 text-center"
              style="font-size: 20px"
            >
              <span> Are you sure ? </span>
            </v-card-text>
            <v-card-text
              class="black--text text-center"
              style="font-size: 14px"
            >
              Do you really want to delete this record ?
              <p class="mb-0">This process cannot be undone.</p>
            </v-card-text>
            <div class="mx-4">
              <v-divider></v-divider>
            </div>
            <v-card-actions class="px-4 py-5 justify-center">
              <div>
                <v-spacer></v-spacer>
                <v-btn
                  outlined
                  class="mr-2 px-5"
                  right
                  height="44"
                  depressed
                  color="primary"
                  style="font-weight: 600"
                  @click="deleteWarningDialog = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  right
                  height="44"
                  color="error"
                  class="px-5"
                  style="font-weight: 600"
                  @click="deleteRecord"
                >
                  Delete
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
      <v-dialog v-model="bullHistoryDialog" max-width="876px">
        <v-form
          ref="bullHistoryForm"
          v-model="bullHistoryFormValid"
          lazy-validation
          @submit.prevent="submitBullHistoryForm"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" dark class="text-h6">
              <div v-if="isEdit && tableEdit">
                Edit Current Record
                <v-tooltip top color="black" max-width="350">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="red" v-bind="attrs" v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span>{{
                    ` Do you really want to edit this record ? Your previous records might get affected.`
                  }}</span>
                </v-tooltip>
              </div>
              <div v-else-if="isEdit">Edit Current Record</div>
              <div v-else>Add New Record</div>
              <v-spacer></v-spacer>
              <v-btn
                icon
                class="white--text"
                @click="closeBullHistoryFormDialog"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <div class="px-5 py-5">
              <v-row>
                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Date of Observation
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{ $t("animal.breedingTooltip.observationDate") }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-menu
                    v-model="observationDateModel"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="bullHistoryFormData.observation_date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        v-on:click:append="observationDateModel = true"
                        placeholder="Select date"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="bullHistoryFormData.observation_date"
                      @input="observationDateModel = false"
                    ></v-date-picker>
                  </v-menu> </v-col
                ><v-col class="py-0" sm="6">
                  <label class="label"
                    >Physical Examination
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{ $t("animal.breedingTooltip.physicalExamination") }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select"
                    dense
                    item-text="value"
                    item-value="id"
                    :items="physicalExaminationOptions"
                    v-model="bullHistoryFormData.physical_examination"
                  ></v-select> </v-col
                ><v-col class="py-0" sm="6">
                  <label class="label"
                    >Lipido and Serving Capacity Tests
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t("animal.breedingTooltip.libidoAndServingTest")
                        }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-text-field
                    v-model="bullHistoryFormData.lipido_serving_capacity_test"
                    placeholder="Enter value"
                    outlined
                    dense
                  ></v-text-field></v-col
                ><v-col class="py-0" sm="3">
                  <label class="label"
                    >Scrotal circumferance
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{ $t("animal.breedingTooltip.scrotalCircumference") }}
                      </span>
                    </v-tooltip></label
                  >

                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    type="number"
                    :min="0"
                    oninput="this.value = Math.abs(this.value)"
                    v-model="bullHistoryFormData.scrotal_circumferance_value"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label">{{ "." }} </label>
                  <v-select
                    outlined
                    placeholder="Select Unit"
                    dense
                    v-model="bullHistoryFormData.scrotal_circumferance_unit"
                    :items="scrotalCircumferanceUnit"
                  ></v-select>
                </v-col>
                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Are Testes Symmetrical ?
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t("animal.breedingTooltip.symmetricalSizeOfTestes")
                        }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select"
                    dense
                    :items="testesOptions"
                    item-value="id"
                    item-text="value"
                    v-model="bullHistoryFormData.air_testes_symmetrical"
                  ></v-select> </v-col
                ><v-col class="py-0" sm="6">
                  <label class="label"
                    >Venereal Diseases
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{ $t("animal.breedingTooltip.veneralDisease") }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select"
                    dense
                    :items="venerealDiseaseOptions"
                    item-text="value"
                    item-value="id"
                    v-model="bullHistoryFormData.venereal_diseases"
                  ></v-select> </v-col
                ><v-col class="py-0" sm="6">
                  <label class="label"
                    >Physical Examination Notes
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{
                          $t("animal.breedingTooltip.physicalExaminationNotes")
                        }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-text-field
                    v-model="bullHistoryFormData.physical_examination_notes"
                    placeholder="Enter value"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                outlined
                @click="closeBullHistoryFormDialog"
              >
                Cancel
              </v-btn>
              <v-btn depressed color="primary" type="submit"> Submit </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="laboratoryDialog" max-width="876px">
        <v-form
          ref="laboratoryForm"
          v-model="laboratoryValid"
          lazy-validation
          @submit.prevent="submitLaboratoryForm"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" dark class="text-h6">
              <div v-if="isEdit && tableEdit">
                Edit Current Record
                <v-tooltip top color="black" max-width="350">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="red" v-bind="attrs" v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span>{{
                    ` Do you really want to edit this record ? Your previous records might get affected.`
                  }}</span>
                </v-tooltip>
              </div>
              <div v-else-if="isEdit">Edit Current Record</div>
              <div v-else>Add New Record</div>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeLabFormDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <div class="px-5 py-5">
              <v-row>
                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Semen Appearance
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{ $t("animal.breedingTooltip.semenAppearance") }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select Color"
                    dense
                    :items="semenAppearanceOptionns"
                    item-text="value"
                    item-value="id"
                    v-model="laboratoryFormData.semen_appearance"
                  ></v-select> </v-col
                ><v-col class="py-0" sm="3">
                  <label class="label"
                    >Sperm Concentration
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{ $t("animal.breedingTooltip.spermConcentration") }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    type="number"
                    :min="0"
                    oninput="this.value = Math.abs(this.value)"
                    v-model="laboratoryFormData.sperm_concentration_value"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label">{{ "." }} </label>
                  <v-select
                    outlined
                    placeholder="Select Taste"
                    dense
                    v-model="laboratoryFormData.sperm_concentration_unit"
                    :items="spermConcentrationUnitOptions"
                  ></v-select> </v-col
                ><v-col class="py-0" sm="3">
                  <label class="label"
                    >Sperm Viability
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{ $t("animal.breedingTooltip.spermViability") }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    type="number"
                    :min="0"
                    oninput="this.value = Math.abs(this.value)"
                    v-model="laboratoryFormData.sperm_viability_value"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label">{{ "." }} </label>
                  <v-select
                    outlined
                    placeholder="Select Taste"
                    dense
                    v-model="laboratoryFormData.sperm_viability_unit"
                    :items="spermViabilityUnitOptions"
                  ></v-select> </v-col
                ><v-col class="py-0" sm="3">
                  <label class="label"
                    >Sperm Mobility
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{ $t("animal.breedingTooltip.spermMotility") }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    type="number"
                    :min="0"
                    oninput="this.value = Math.abs(this.value)"
                    v-model="laboratoryFormData.sperm_mobility_value"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label">{{ "." }} </label>
                  <v-select
                    outlined
                    placeholder="Select Taste"
                    dense
                    v-model="laboratoryFormData.sperm_mobility_unit"
                    :items="spermMobilityUnitOptions"
                  ></v-select> </v-col
                ><v-col class="py-0" sm="3">
                  <label class="label"
                    >Sperm Morphology
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{ $t("animal.breedingTooltip.spermMorphology") }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    type="number"
                    :min="0"
                    oninput="this.value = Math.abs(this.value)"
                    v-model="laboratoryFormData.sperm_morphology_value"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label">{{ "." }} </label>
                  <v-select
                    outlined
                    placeholder="Select Taste"
                    dense
                    v-model="laboratoryFormData.sperm_morphology_unit"
                    :items="spermMorphologyUnitOptions"
                  ></v-select> </v-col
                ><v-col class="py-0" sm="6">
                  <label class="label"
                    >Notes
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t("animal.notes") }} </span>
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    v-model="laboratoryFormData.notes"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                outlined
                @click="closeLabFormDialog"
              >
                Cancel
              </v-btn>
              <v-btn depressed color="primary" type="submit"> Submit </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <div class="d-flex mb-4 align-center">
        <h2>Fertility</h2>
        <v-spacer></v-spacer>
        <div>
          <v-btn
            height="50"
            width="300"
            color="primary"
            outlined
            v-show="!disableCurrentRecordButton"
            @click="startEdit(null)"
            >EDIT CURRENT RECORD</v-btn
          >
        </div>
        <div class="ml-5">
          <div class="d-flex justify-end">
            <v-btn
              height="50"
              width="200"
              @click="showBullHistoryForm"
              dense
              depressed
              color="primary"
              :disabled="panel == undefined"
              >ADD NEW RECORD</v-btn
            >
          </div>
        </div>
      </div>
      <v-row width="100%" justiry="center">
        <v-col cols="12" md="4">
          <v-card class="pa-2 green2 elevation-0">
            <v-list class="green2">
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-subtitle
                    >Date of Observation
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{
                        $t("animal.breedingTooltip.observationDate")
                      }}</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                  <v-list-item-title class="text-h6 mt-2">
                    {{
                      currentBullHistoryRecord &&
                      currentBullHistoryRecord.observation_date
                        ? formatDate(
                            currentBullHistoryRecord.observation_date,
                            "DD/MM/YYYY"
                          )
                        : "Not Specified"
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card class="pa-2 green2 elevation-0">
            <v-list class="green2">
              <v-list-item three-line>
                <v-list-item-content
                  ><v-list-item-subtitle
                    >Physical Examination
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{
                        $t("animal.breedingTooltip.physicalExamination")
                      }}</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                  <v-list-item-title class="text-h6 mt-2">
                    {{
                      currentBullHistoryRecord &&
                      currentBullHistoryRecord.physical_examination
                        ? getPhysicalExamination(currentBullHistoryRecord)
                        : "Not Specified"
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card class="pa-2 green2 elevation-0">
            <v-list class="green2">
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-subtitle
                    >Lipido and Serving Capacity Tests
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{
                        $t("animal.breedingTooltip.libidoAndServingTest")
                      }}</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                  <v-list-item-title class="text-h6 mt-2">
                    {{
                      currentBullHistoryRecord &&
                      currentBullHistoryRecord.lipido_serving_capacity_test
                        ? currentBullHistoryRecord.lipido_serving_capacity_test
                        : "Not Specified"
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card class="pa-2 green2 elevation-0">
            <v-list class="green2">
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-subtitle
                    >Scrotal Circumference
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{
                        $t("animal.breedingTooltip.scrotalCircumference")
                      }}</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                  <v-list-item-title class="text-h6 mt-2">
                    {{
                      currentBullHistoryRecord &&
                      currentBullHistoryRecord.scrotal_circumferance_value
                        ? currentBullHistoryRecord.scrotal_circumferance_value
                        : "Not Specified"
                    }}
                    {{
                      currentBullHistoryRecord &&
                      currentBullHistoryRecord.scrotal_circumferance_unit
                        ? currentBullHistoryRecord.scrotal_circumferance_unit
                        : "Not Specified"
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card class="pa-2 green2 elevation-0">
            <v-list class="green2">
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-subtitle
                    >Symmetrical Size of Testes
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{
                        $t("animal.breedingTooltip.symmetricalSizeOfTestes")
                      }}</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                  <v-list-item-title class="text-h6 mt-2">
                    {{
                      currentBullHistoryRecord &&
                      currentBullHistoryRecord.air_testes_symmetrical
                        ? getTestes(currentBullHistoryRecord)
                        : "Not Specified"
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card class="pa-2 green2 elevation-0">
            <v-list class="green2">
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-subtitle
                    >Venereal Diseases
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{
                        $t("animal.breedingTooltip.veneralDisease")
                      }}</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                  <v-list-item-title class="text-h6 mt-2">
                    {{
                      currentBullHistoryRecord &&
                      currentBullHistoryRecord.venereal_diseases
                        ? getVenerealDiseases(currentBullHistoryRecord)
                        : "Not Specified"
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
      <v-row width="100%" justify="center">
        <v-col cols="12">
          <div>
            <label class="mt-5"> Bull History</label>
            <v-data-table
              class="mt-5 rounded-xl"
              :headers="bullHistoryHeaders"
              :items="bullHistoryRecord"
              :items-per-page="20"
              hide-default-footer
              :loading="loading"
              loading-text="Loading Data..."
            >
              <template v-slot:item.createdAt="{ item }">
                <div>
                  {{ item.createdAt | formatDate }}
                </div>
              </template>
              <template v-slot:item.observation_date="{ item }">
                <div>
                  {{ item.observation_date | formatDate }}
                </div>
              </template>
              <template v-slot:item.physical_examination="{ item }">
                <div>
                  {{ getPhysicalExamination(item) }}
                </div>
              </template>
              <template v-slot:item.air_testes_symmetrical="{ item }">
                <div>
                  {{ getTestes(item) }}
                </div>
              </template>

              <template v-slot:item.action="{ item }">
                <div>
                  <v-row>
                    <v-col sm="6">
                      <v-icon
                        dark
                        color="gray"
                        @click="
                          startEdit(item);
                          tableEdit = true;
                        "
                      >
                        mdi-pencil
                      </v-icon>
                    </v-col>
                    <v-col sm="6">
                      <v-icon
                        dark
                        color="red"
                        @click="startDelete('bull-history', item)"
                      >
                        mdi-delete
                      </v-icon>
                    </v-col>
                  </v-row>
                </div>
              </template>
              <template v-slot:footer></template>
            </v-data-table>
          </div>
        </v-col>
      </v-row>

      <v-row width="100%" justify="center">
        <v-col cols="12">
          <div>
            <div class="d-flex mb-4 align-center">
              <label class="mt-5"> Laboratory Results</label>
              <v-spacer></v-spacer>

              <div class="d-flex justify-end">
                <v-btn
                  height="50"
                  width="100"
                  dense
                  depressed
                  color="primary"
                  :disabled="panel == undefined"
                  @click="showLaboratoryForm"
                  ><span>+</span> ADD</v-btn
                >
              </div>
            </div>
            <v-data-table
              class="mt-5 rounded-xl"
              :headers="laboratoryHeaders"
              :items="laboratoryRecord"
              :items-per-page="20"
              hide-default-footer
              :loading="loading"
              loading-text="Loading Data..."
            >
              <template v-slot:item.createdAt="{ item }">
                <div>
                  {{ item.createdAt | formatDate }}
                </div>
              </template>
              <template v-slot:item.semen_appearance="{ item }">
                <div>
                  {{ getSemenAppearance(item) }}
                </div>
              </template>

              <template v-slot:item.action="{ item }">
                <div>
                  <v-row>
                    <v-col sm="6">
                      <v-icon
                        dark
                        color="gray"
                        @click="editLaboratoryForm(item)"
                      >
                        mdi-pencil
                      </v-icon>
                    </v-col>
                    <v-col sm="6">
                      <v-icon
                        dark
                        color="red"
                        @click="startDelete('lab', item)"
                      >
                        mdi-delete
                      </v-icon>
                    </v-col>
                  </v-row>
                </div>
              </template>
              <template v-slot:footer></template>
            </v-data-table>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import loading from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";
import {
  getBullHistoryRecordByAnimalId,
  getLaboratoryResultRecordByAnimalId,
  createBullHistoryRecord,
  createLaboratoryResultRecord,
  updateBullHistoryRecord,
  updateLaboratoryResultRecord,
  deleteBullHistoryRecordById,
  deleteLaboratoryResultRecordById,
} from "@/graphql/Reproduction.gql";
import moment from "moment";

export default {
  apollo: {
    getBullHistoryRecordByAnimalId: {
      query: getBullHistoryRecordByAnimalId,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
      result: function ({ data }) {
        if (data) {
          this.currentBullHistoryRecord =
            data.getBullHistoryRecordByAnimalId[0] || null;
          this.bullHistoryRecord = data.getBullHistoryRecordByAnimalId;
        }
      },
      update: (data) => {
        console.log(data);
      },
      error: (err) =>
        this.$notify({
          title: "Error loading data!",
          text: err,
          type: "error",
          position: "top right",
        }),
    },

    getLaboratoryResultRecordByAnimalId: {
      query: getLaboratoryResultRecordByAnimalId,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
      result: function ({ data }) {
        if (data) {
          this.currentBullLaboratoryRecord =
            data.getLaboratoryResultRecordByAnimalId[0] || null;
          this.laboratoryRecord = data.getLaboratoryResultRecordByAnimalId;
        }
      },
      update: (data) => {
        console.log(data);
      },
      error: (err) =>
        this.$notify({
          title: "Error loading data!",
          text: err,
          type: "error",
          position: "top right",
        }),
    },
  },
  created() {
    console.log("treatment");
  },
  mixins: [generalMixin, loading],
  data() {
    return {
      observationDateModel: false,
      deleteDataType: null,
      loading: false,
      tableEdit: false,
      currentEditItem: null,
      editDialog: false,
      deleteWarningDialog: false,
      bullHistoryDialog: false,
      laboratoryDialog: false,
      bullHistoryHeaders: [
        {
          text: "Date of Observation",
          align: "start",
          sortable: true,
          value: "observation_date",
        },
        {
          text: "Physical Examination",
          align: "start",
          sortable: true,
          value: "physical_examination",
        },
        {
          text: "Lipido and Serving Capacity Tests",
          align: "start",
          sortable: true,
          value: "lipido_serving_capacity_test",
        },
        {
          text: "Scrotal Circumference",
          align: "start",
          sortable: true,
          value: "scrotal_circumferance_value",
        },
        {
          text: "Symmetrical Size of Testes",
          align: "start",
          sortable: true,
          value: "air_testes_symmetrical",
        },
        {
          text: "",
          align: "start",
          sortable: true,
          value: "action",
        },
      ],
      laboratoryHeaders: [
        {
          text: "Date Uploaded",
          align: "start",
          sortable: true,
          value: "createdAt",
        },
        {
          text: "Semen Appearance",
          align: "start",
          sortable: true,
          value: "semen_appearance",
        },
        {
          text: "Sperm Concentration",
          align: "start",
          sortable: true,
          value: "sperm_concentration_value",
        },
        {
          text: "Sperm Viability",
          align: "start",
          sortable: true,
          value: "sperm_viability_value",
        },
        {
          text: "Sperm Mobility",
          align: "start",
          sortable: true,
          value: "sperm_mobility_value",
        },
        {
          text: "Sperm Morphology",
          align: "start",
          sortable: true,
          value: "sperm_morphology_value",
        },
        {
          text: "Notes",
          align: "start",
          sortable: true,
          value: "notes",
        },
        {
          text: "Reports",
          align: "start",
          sortable: true,
          value: "report",
        },
        {
          text: "",
          align: "start",
          sortable: true,
          value: "action",
        },
      ],
      bullHistoryFormValid: false,
      laboratoryValid: false,
      bullHistoryFormData: {},
      laboratoryFormData: {},
      panel: 0,
      isEdit: false,
      currentBullHistoryRecord: null,
      currentBullLaboratoryRecord: null,
      bullHistoryRecord: [],
      laboratoryRecord: [],
    };
  },
  methods: {
    getSemenAppearance(item) {
      let semenAppearanceData = this.semenAppearanceOptionns.find(
        (data) => data.id == item.semen_appearance
      );

      return semenAppearanceData.value ?? "Not-specified";
    },
    getPhysicalExamination(item) {
      let physicalData = this.physicalExaminationOptions.find(
        (data) => data.id == item.physical_examination
      );

      return physicalData.value ?? "Not-specified";
    },
    getTestes(item) {
      let testesData = this.testesOptions.find(
        (data) => data.id == item.air_testes_symmetrical
      );

      return testesData.value ?? "Not-specified";
    },
    getVenerealDiseases(item) {
      let venerealDiseaseData = this.venerealDiseaseOptions.find(
        (data) => data.id == item.venereal_diseases
      );

      return venerealDiseaseData.value ?? "Not-specified";
    },
    showLaboratoryForm() {
      this.isEdit = false;
      this.laboratoryFormData = {};
      this.laboratoryDialog = true;
    },
    showBullHistoryForm() {
      this.isEdit = false;
      this.bullHistoryFormData = {};
      this.bullHistoryDialog = true;
    },
    getEditRecord() {
      if (this.panel == 0) {
        return this.currentMilkRecord || this.breedingRecordData[0];
      } else if (this.panel == 1) {
        return this.currentPhysioRecord || this.heatDetectionRecordData[0];
      } else if (this.panel == 2) {
        return this.currentBullHistoryRecord || this.microRecordData[0];
      }
    },
    closeEditConfirmation() {
      this.editDialog = false;
    },

    async deleteRecord() {
      if (this.deleteDataType == "bull-history") {
        this.startLoading();
        try {
          await this.$apollo.mutate({
            mutation: deleteBullHistoryRecordById,
            variables: {
              id: Number(this.bullHistoryFormData.id),
            },
          });
          this.$notify({
            title: `Record deleted successfully`,
            type: "success",
            position: "top right",
          });
          this.deleteWarningDialog = false;
          this.$apollo.queries.getBullHistoryRecordByAnimalId.refetch();
          this.currentBullHistoryRecord = await this.bullHistoryRecord[0];
        } catch (error) {
          this.stopLoading();
        }
        this.stopLoading();
      } else if (this.deleteDataType == "lab") {
        this.startLoading();
        try {
          await this.$apollo.mutate({
            mutation: deleteLaboratoryResultRecordById,
            variables: {
              id: Number(this.laboratoryFormData.id),
            },
          });
          this.$apollo.queries.getLaboratoryResultRecordByAnimalId.refetch();
          this.deleteWarningDialog = false;
          this.currentBullLaboratoryRecord = await this
            .getBullHistoryRecordByAnimalId[0];
          this.$notify({
            title: `Record Deleted Successfully`,
            type: "success",
            position: "top right",
          });
        } catch (error) {
          this.stopLoading();
        }
        this.stopLoading();
      }
    },
    startEdit(item) {
      this.editDialog = false;
      if (this.panel == 0) {
        this.isEdit = true;
        this.currentBullHistoryRecord = item || this.bullHistoryRecord[0];
        this.bullHistoryFormData = item || this.breedingRecordData[0];
        this.bullHistoryFormData.observation_date = this.bullHistoryFormData
          .observation_date
          ? moment(this.bullHistoryFormData.observation_date).format(
              "YYYY-MM-DD"
            )
          : null;
        this.bullHistoryDialog = true;
      }
    },

    startDelete(type, item) {
      if (type == "bull-history") {
        this.bullHistoryFormData = item;
        this.deleteDataType = type;
        this.deleteWarningDialog = true;
      } else if (type == "lab") {
        this.laboratoryFormData = item;
        this.deleteDataType = type;
        this.deleteWarningDialog = true;
      }
    },
    startCreate() {
      if (this.panel == 0) {
        this.isEdit = false;
        this.bullHistoryFormData = {};
        this.breedingFormDialog = true;
      } else if (this.panel == 1) {
        this.isEdit = false;
        this.heatDetectionFormData = {};
        this.heatDetectionDialog = true;
      } else if (this.panel == 2) {
        this.isEdit = false;
        this.laboratoryFormData = {};
        this.breedingRecordFormDialog = true;
      } else if (this.panel == 3) {
        this.isEdit = false;
        this.pregnancyFormData = {};
        this.pregnancyFormDialog = true;
      }
    },
    closeBullHistoryFormDialog() {
      this.bullHistoryFormData = {};
      this.bullHistoryDialog = false;
    },
    closeLabFormDialog() {
      this.laboratoryFormData = {};
      this.laboratoryDialog = false;
    },
    async submitBullHistoryForm() {
      if (Object.keys(this.bullHistoryFormData).length == 0) {
        this.$notify({
          text: "No details entered.",
          type: "error",
          position: "top right",
        });
        return;
      }

      this.bullHistoryFormData.animalId = Number(
        this.$route.params.animal_number
      );
      this.bullHistoryFormData.scrotal_circumferance_value = Number(
        this.bullHistoryFormData.scrotal_circumferance_value
      );
      this.startLoading();
      if (this.isEdit) {
        delete this.bullHistoryFormData.__typename;
        this.bullHistoryFormData.id = Number(this.bullHistoryFormData.id);
        try {
          await this.$apollo.mutate({
            mutation: updateBullHistoryRecord,
            variables: {
              bullHistoryRecordInput: this.bullHistoryFormData,
              recordId: this.bullHistoryFormData.id,
            },
          });
          this.$notify({
            title: `Data updated successfully`,
            type: "success",
            position: "top right",
          });

          this.bullHistoryDialog = false;
          this.$apollo.queries.getBullHistoryRecordByAnimalId.refetch();
          this.currentBullHistoryRecord = this.bullHistoryRecord[0];
        } catch (e) {
          this.stopLoading();
          this.closeBullHistoryFormDialog();
          // this.$notify({
          //   title: `Problem with data.`,
          //   text: e.message,
          //   type: "error",
          //   position: "top right",
          // });
        }
      } else {
        try {
          await this.$apollo.mutate({
            mutation: createBullHistoryRecord,
            variables: {
              bullHistoryRecordInput: this.bullHistoryFormData,
            },
          });
          this.$notify({
            title: `Data added successfully`,
            type: "success",
            position: "top right",
          });
          this.bullHistoryDialog = false;
          this.$apollo.queries.getBullHistoryRecordByAnimalId.refetch();
          this.currentBullHistoryRecord = this.bullHistoryRecord[0];
        } catch (e) {
          this.stopLoading();
          this.closeBullHistoryFormDialog();
          // this.$notify({
          //   title: `Problem with data.`,
          //   text: e.message,
          //   type: "error",
          //   position: "top right",
          // });
        }
      }

      this.stopLoading();
    },

    async submitLaboratoryForm() {
      if (Object.keys(this.laboratoryFormData).length == 0) {
        this.$notify({
          text: "No details entered.",
          type: "error",
          position: "top right",
        });
        return;
      }

      this.laboratoryFormData.animalId = Number(
        this.$route.params.animal_number
      );
      this.laboratoryFormData.sperm_concentration_value = Number(
        this.laboratoryFormData.sperm_concentration_value
      );
      this.laboratoryFormData.sperm_viability_value = Number(
        this.laboratoryFormData.sperm_viability_value
      );
      this.laboratoryFormData.sperm_mobility_value = Number(
        this.laboratoryFormData.sperm_mobility_value
      );
      this.laboratoryFormData.sperm_morphology_value = Number(
        this.laboratoryFormData.sperm_morphology_value
      );
      this.startLoading();
      if (this.isEdit) {
        this.laboratoryFormData.id = Number(this.laboratoryFormData.id);
        delete this.laboratoryFormData.createdAt;
        delete this.laboratoryFormData.__typename;
        try {
          await this.$apollo.mutate({
            mutation: updateLaboratoryResultRecord,
            variables: {
              laboratoryResultRecordInput: this.laboratoryFormData,
              recordId: this.laboratoryFormData.id,
            },
          });
          this.$notify({
            title: `Data updated successfully`,
            type: "success",
            position: "top right",
          });

          this.laboratoryDialog = false;
          this.$apollo.queries.getLaboratoryResultRecordByAnimalId.refetch();
        } catch (e) {
          this.stopLoading();
          this.closeBullHistoryFormDialog();
          // this.$notify({
          //   title: `Problem with data.`,
          //   text: e.message,
          //   type: "error",
          //   position: "top right",
          // });
        }
      } else {
        try {
          await this.$apollo.mutate({
            mutation: createLaboratoryResultRecord,
            variables: {
              laboratoryResultRecordInput: this.laboratoryFormData,
            },
          });
          this.$notify({
            title: `Data added successfully`,
            type: "success",
            position: "top right",
          });
          this.laboratoryDialog = false;
          this.$apollo.queries.getLaboratoryResultRecordByAnimalId.refetch();
          this.currentBullLaboratoryRecord = this.laboratoryRecord[0];
        } catch (e) {
          this.stopLoading();
          this.closeBullHistoryFormDialog();
          // this.$notify({
          //   title: `Problem with data.`,
          //   text: e.message,
          //   type: "error",
          //   position: "top right",
          // });
        }
      }

      this.stopLoading();
    },

    async editLaboratoryForm(item) {
      this.isEdit = true;
      this.laboratoryFormData = item;
      this.laboratoryDialog = true;
    },
  },
  computed: {
    ...mapGetters([""]),
    spermConcentrationUnitOptions() {
      return ["million/ml"];
    },
    spermViabilityUnitOptions() {
      return ["% Vaible"];
    },
    spermMobilityUnitOptions() {
      return ["% motile"];
    },
    spermMorphologyUnitOptions() {
      return ["% normal s"];
    },
    semenAppearanceOptionns() {
      return [{ id: 1, value: "Opaque" }];
    },
    venerealDiseaseOptions() {
      return [
        { id: 1, value: "No disease" },
        { id: 2, value: "Campylo bacteriosis(Vibriosis)" },
        { id: 3, value: "Tricomoniais" },
        { id: 4, value: "Bovine herpus virus" },
        { id: 5, value: "Hemophilus Somnus" },
        { id: 6, value: "Ureaplasma" },
        { id: 7, value: "Mycoplasma" },
        { id: 8, value: "others" },
      ];
    },
    scrotalCircumferanceUnit() {
      return ["cm"];
    },
    testesOptions() {
      return [
        { id: 1, value: "Yes" },
        { id: 2, value: "No" },
      ];
    },
    physicalExaminationOptions() {
      return [
        { id: 1, value: "Fit" },
        { id: 2, value: "Unfit" },
        { id: 3, value: "Others" },
      ];
    },
    disableCurrentRecordButton() {
      if (this.panel == undefined) {
        return true;
      } else if (this.panel == 0 && !this.currentMilkRecord) {
        return true;
      } else if (this.panel == 1 && !this.currentPhysioRecord) {
        return true;
      } else if (this.panel == 2 && !this.currentBullHistoryRecord) {
        return true;
      } else {
        return false;
      }
    },
    acidityRawUnitOptions() {
      return ["pH"];
    },
    specificGravityUnitOptions() {
      return ["° C"];
    },
    snfUnitOptions() {
      return ["%"];
    },
    proteinContentUnitOptions() {
      return ["kg", "lb(s)", "liter(s)"];
    },
    fatContentUnitOptions() {
      return ["%"];
    },
    milkYieldUnitOptions() {
      return ["kg", "lb(s)", "liter(s)"];
    },
    proteinYieldUnitOptions() {
      return ["kg", "lb(s)"];
    },
    milkLactoseUnitOptions() {
      return ["%"];
    },
    milkUreaUnitOptions() {
      return ["mg", "dl"];
    },
    milkColorOptions() {
      return [
        "Yellow",
        "Cream White",
        "White with Flakes",
        "Yellow with Flakes",
        "Red",
        "Other",
      ];
    },
    milkTasteOptions() {
      return [
        "Slightly Sweet",
        "Sour",
        "Soapy Bitter/Rancid Flavour",
        "Metallic/Cardboardy",
        "Feed Flavor",
        "Fermented",
        "Putrid Malty Flavor",
        "Cowy",
        "Nutty",
        "Salty",
      ];
    },
    milkSmellOptions() {
      return [
        "No Smell",
        "Odor",
        "Rotten",
        "Smell",
        "Fishy off-Flavour",
        "Rancid Odor",
        "Other",
      ];
    },
    locationNumberOptions() {
      return [1, 2, 3, 4, 5];
    },
    locationLengthOptions() {
      return [1, 2, 3, 4, 5];
    },
    locationLengthUnitOptions() {
      return ["days", "weeks", "months", "years"];
    },
    milkFrequencyOptions() {
      return [1, 2, 3, 4, 5];
    },
    somaticCellData() {
      return [
        "100,000 cells/ml",
        "100000-199000",
        "200000-299000",
        "300000-399000",
        ">400000",
      ];
    },

    somaticCellResultData() {
      return {
        "100,000 cells/ml": "Normal",
        "100000-199000": "Required Observation",
        "200000-299000": "Suspected",
        "300000-399000": "Affected",
        ">400000": "Suffering",
      };
    },
    preliminaryIncubationCountData() {
      return ["<100000 cfu/ml", "10,000-50000 cfu/ml", ">50,000 cfu/ml"];
    },
    preliminaryIncubationResultData() {
      return {
        "<100000 cfu/ml": "Ideal",
        "10,000-50000 cfu/ml": "Acceptable",
        ">50,000 cfu/ml": "Concerned",
      };
    },
    viableCountData() {
      return ["<5000", "5000-10000", ">10,000"];
    },
    viableCountResultData() {
      return {
        "<5000": "Recommended",
        "5000-10000": "Medium",
        ">10,000": "High",
      };
    },

    coliformCountData() {
      return ["<50", "50-100", ">10,000"];
    },
    coliformCountResultData() {
      return { "<50": "Recommended", "50-100": "Medium", ">10,000": "High" };
    },
    yeastMouldCountData() {
      return ["<30", "30-50", ">50"];
    },
    yeastMouldResultData() {
      return {
        "<30": "Acceptable",
        "30-50": "Satisfactory Quality",
        ">50": "Affected",
      };
    },
    antiMicrobialData() {
      return ["Negative", "Positive"];
    },
  },
  mounted() {
    this.panel = 0;
  },
  watch: {
    refreshProp() {
      this.panel = 0;
    },
  },
  props: ["treatment", "refreshProp"],
};
</script>

<style lang="scss" scoped>
.v-expansion-panel {
  margin-top: 10px;
}
.v-expansion-panel-header {
  background: #f3f3f380;
  border-radius: 5px;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0;
}

.card-border-content {
  color: var(--Secondary-1, #00bd73);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.7px;
}
.card-border-content-pointer {
  cursor: pointer;
}
</style>
